import { defineStore } from 'pinia'
import {computed, ref} from 'vue'
import { useGlobalStore } from '@/stores/index'
import  {useFilterStore } from '@/stores/filter'
import api from '@/api'
import { useAbstractPartsStore } from '@/stores/abstract-parts'

export const usePartsStore = defineStore('parts', () =>
{
    const currentPage = ref(1)
    const itemsPerPage = ref(50)
    const numberOfPages = ref(0)
    const numberOfTotalItems = ref(0)
    const items = ref([])

    const globals = useGlobalStore()
    const filter = useFilterStore()
    const partsGlobals = useAbstractPartsStore()

    const imagePath = partsGlobals.imagePath

    const getParams = computed(() =>
    {
        let searchTermToUse = filter.searchTerm
        let params = {
            page: currentPage.value,
            itemsPerPage: itemsPerPage.value,
            search: searchTermToUse,
            withFilters: 'true',
            'X-LOCALE': globals.locale
        }
        if (globals.channel) {
            params['channel'] = globals.channel
        }
        if (filter.selectedFilters) {
            for (const [key] of Object.entries(filter.selectedFilters))
            {
                if (filter.selectedFilters[key].length)
                {
                    let arr = []
                    for (const selectedF of filter.selectedFilters[key])
                    {
                        arr.push(selectedF.searchTerm)
                    }
                    params[key] = arr
                }
            }
        }
        if (filter.rangeFilters) {
            for (const [group] of Object.entries(filter.rangeFilters))
            {
                if (filter.rangeFilters[group].options.length)
                {
                    if (filter.rangeFilters[group].options[0].min === filter.rangeFilters[group].options[1].max)
                    {
                      if (filter.rangeFilters[group].options[0].min !== null)
                      {
                        params[group + '[min]'] = filter.rangeFilters[group].options[0].min
                        params[group + '[max]'] = filter.rangeFilters[group].options[0].min
                      }
                    }
                }
            }
        }
        return params
    })

    async function getItems ()
    {
        globals.loading = true
        await api.get(partsGlobals.apiUrlGetParts.value, {params: { ...getParams.value } })
            .then(response =>
            {
                numberOfTotalItems.value = response.data['hydra:totalItems']
                items.value = [...response.data['hydra:member']]
                // currentPage.value = 1
                numberOfPages.value = Math.ceil(numberOfTotalItems.value / itemsPerPage.value)
                filter.filters = response.data['hydra:meta'].filters
                filter.updateRangeFilter()
                globals.loading = false
            }).catch(() =>
            {
                globals.error = true
            })
    }

    return {
        itemsPerPage,
        items,
        imagePath,
        currentPage,
        numberOfPages,
        numberOfTotalItems,
        getItems,
    }
})
